import {memo} from "react";
import SearchQueryGenerator from "./searchQueryGenerator";

const SearchCreator = (props) => {
  const {options = [], placeholder = "Search", onChange = () => {}} = props;

  return (
    <SearchQueryGenerator
      placeholder={placeholder}
      options={options}
      onChange={onChange}
    />
  );
};

export default memo(SearchCreator);
